import React from 'react';
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled, { css } from 'styled-components';
import { SpotlightCard, SpotlightPulse } from '@atlaskit/onboarding';
import { layers } from '@atlaskit/theme/constants';
import { token } from '@atlaskit/tokens';
import { expVal } from '@atlassian/jira-feature-experiments';
import { useIntl } from '@atlassian/jira-intl';
import messages from '../../../../../../common/messages.tsx';
import type { SpotlightContainerProps } from './types.tsx';

export const SpotlightContainer = ({ children }: SpotlightContainerProps) => {
	const { formatMessage } = useIntl();

	/**
	 * Atlaskit Popup was not used due to technical limitations of the component in this particular use case.
	 * onClose is triggered when the popup is controlled by focussing, which causes the popup to immediately close.
	 */
	return (
		// eslint-disable-next-line jira/integration/test-id-by-folder-structure
		<SpotlightContainerWrapper data-testid="issue-create.ui.modal.header.spotlight-container.wrapper">
			{children}
			<SpotlightPopoverWrapper zIndex={layers.spotlight()}>
				<SpotlightCard width={275}>
					{formatMessage(
						expVal('issue-terminology-refresh-m2-replace', 'isEnabled', false)
							? messages.resizeSpotlightMessageIssueTermRefresh
							: messages.resizeSpotlightMessage,
					)}
				</SpotlightCard>
			</SpotlightPopoverWrapper>
		</SpotlightContainerWrapper>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SpotlightPopoverWrapper = styled.div<{ zIndex: number }>(
	{
		position: 'absolute',
		top: 'calc(100% + 5px)', // Size of the border of the SpotlightPulse + 3px from design
		right: token('space.negative.025'), // Size of the border of the SpotlightPulse
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	({ zIndex }) =>
		zIndex &&
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
		css({
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
			zIndex,
		}),
);

// eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SpotlightContainerWrapper = styled(SpotlightPulse)({
	position: 'relative',
});
